// extracted by mini-css-extract-plugin
export default {"container":"hE-z","header":"iE-z","details":"jE-z","link":"kE-z"};